import { Spinner } from './spinner';
import { cn } from './lib/utils';

/**
 * Splash Screen component for PWA applications.
 * Displays a loading screen with centered spinner while the application initializes.
 * For PWA, the browser shows a native splash screen based on manifest icons,
 * but this component provides a smooth transition after the app loads.
 */
export const SplashScreen = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'fixed inset-0 z-[9999] flex items-center justify-center bg-white',
        className,
      )}
      style={{
        // Ensure splash screen covers everything
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#F5F4F7', // Match theme_color from manifest
      }}
    >
      <div className="flex flex-col items-center gap-4">
        {/* Centered spinner */}
        <Spinner size={40} />
      </div>
    </div>
  );
};
